function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg166SintEustatius(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.086,
    style: {
      fill: "#D80027"
    },
    width: 511.828,
    height: 511.828
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.216,
    y: 11.127,
    style: {
      fill: "#0052B4"
    },
    width: 489.574,
    height: 489.574
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.44,
    y: 0.172,
    style: {
      fill: "#D80027"
    },
    width: 11.127,
    height: 511.828
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.086,
    y: 250.528,
    style: {
      fill: "#D80027"
    },
    width: 511.828,
    height: 11.127
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "128.043,255.914 256,175.488 383.957,255.914 256,336.341  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "149.489,255.914 256,188.967 362.512,255.914 256,322.861 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6DA544"
    },
    points: "326.766,278.372 314.088,286.35 195.14,286.35 195.802,285.026 210.353,255.914   225.565,271.126 256,271.126 271.212,248.302 286.436,255.914 301.648,240.701 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,210.265 259.777,221.889 271.999,221.889 262.112,229.073 265.888,240.698 256,233.514   246.113,240.698 249.889,229.073 240.002,221.889 252.224,221.889 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg166SintEustatius);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3QgeD0iMC4wODYiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTExLjgyOCIgaGVpZ2h0PSI1MTEuODI4Ii8+CjxyZWN0IHg9IjExLjIxNiIgeT0iMTEuMTI3IiBzdHlsZT0iZmlsbDojMDA1MkI0OyIgd2lkdGg9IjQ4OS41NzQiIGhlaWdodD0iNDg5LjU3NCIvPgo8Zz4KCTxyZWN0IHg9IjI1MC40NCIgeT0iMC4xNzIiIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iMTEuMTI3IiBoZWlnaHQ9IjUxMS44MjgiLz4KCTxyZWN0IHg9IjAuMDg2IiB5PSIyNTAuNTI4IiBzdHlsZT0iZmlsbDojRDgwMDI3OyIgd2lkdGg9IjUxMS44MjgiIGhlaWdodD0iMTEuMTI3Ii8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRDgwMDI3OyIgcG9pbnRzPSIxMjguMDQzLDI1NS45MTQgMjU2LDE3NS40ODggMzgzLjk1NywyNTUuOTE0IDI1NiwzMzYuMzQxICAiLz4KPC9nPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSIxNDkuNDg5LDI1NS45MTQgMjU2LDE4OC45NjcgMzYyLjUxMiwyNTUuOTE0IDI1NiwzMjIuODYxICIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojNkRBNTQ0OyIgcG9pbnRzPSIzMjYuNzY2LDI3OC4zNzIgMzE0LjA4OCwyODYuMzUgMTk1LjE0LDI4Ni4zNSAxOTUuODAyLDI4NS4wMjYgMjEwLjM1MywyNTUuOTE0ICAgMjI1LjU2NSwyNzEuMTI2IDI1NiwyNzEuMTI2IDI3MS4yMTIsMjQ4LjMwMiAyODYuNDM2LDI1NS45MTQgMzAxLjY0OCwyNDAuNzAxICIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgcG9pbnRzPSIyNTYsMjEwLjI2NSAyNTkuNzc3LDIyMS44ODkgMjcxLjk5OSwyMjEuODg5IDI2Mi4xMTIsMjI5LjA3MyAyNjUuODg4LDI0MC42OTggMjU2LDIzMy41MTQgICAyNDYuMTEzLDI0MC42OTggMjQ5Ljg4OSwyMjkuMDczIDI0MC4wMDIsMjIxLjg4OSAyNTIuMjI0LDIyMS44ODkgIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };